import { render } from "./SearchSummaryTotalElementsLabel.vue?vue&type=template&id=1931d54e&scoped=true"
import script from "./SearchSummaryTotalElementsLabel.vue?vue&type=script&lang=js"
export * from "./SearchSummaryTotalElementsLabel.vue?vue&type=script&lang=js"

import "./SearchSummaryTotalElementsLabel.vue?vue&type=style&index=0&id=1931d54e&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1931d54e"]])

export default __exports__